import {
  styled,
  IconButton as BaseIconButton,
  WithTheme,
} from '@material-ui/core'
import { ReactComponent as DropDown } from 'shared/icons/arrow_drop_down.svg'

interface ArrowDropDownProps extends WithTheme {
  direction: 'up' | 'down'
}

const ICON_BUTTON_SIZE = 20

export const Content = styled('div')({
  display: 'flex',
  alignItems: 'center',
  '& .MuiTypography-root': {
    fontWeight: 600,
  },
})

export const IconButton = styled(BaseIconButton)(({ theme }) => ({
  color: theme.palette.common.black,
  marginLeft: theme.spacing(0.3),
  boxSizing: 'border-box',
  height: ICON_BUTTON_SIZE,
  width: ICON_BUTTON_SIZE,
  padding: 0,
  borderRadius: '50%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}))

export const ArrowDropDown = styled(DropDown)(
  ({ theme, direction }: ArrowDropDownProps) => ({
    color: theme.palette.common.black,
    transform: `rotateZ(${direction === 'up' ? 180 : 0}deg)`,
    transition: 'transform 0.3s',
  })
)
